import { IFeedLiveFilters } from '@/types';
import { useLeagueGroupDictionary } from '@/stores';
import { intersectArrays } from '@/helpers/array';

export function useFilteredLeagueIds(filters: IFeedLiveFilters) {
    const leagueGroupDictionary = useLeagueGroupDictionary();

    const filteredLeagueIds = computed<number[] | null>(() => {
        if (filters.leagueGroupId === null && filters.customLeagueId === null) {
            return null;
        }

        const leagueArrays: number[][] = [];

        if (filters.leagueGroupId !== null) {
            const groupLeagues: number[] = [];
            for (const groupId of filters.leagueGroupId) {
                const leagueIds = leagueGroupDictionary.itemById(groupId).customLeagueIds;
                groupLeagues.push(...leagueIds);
            }
            leagueArrays.push(groupLeagues);
        }

        if (filters.customLeagueId !== null) {
            leagueArrays.push(filters.customLeagueId);
        }

        return intersectArrays(...leagueArrays);
    });

    return { filteredLeagueIds };
}
